import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { VueGoodTable } from 'vue-good-table';
import '../../Lib/vue-good-table.css'

import {ImageService} from "../../../../api/ImageService";
import {StoreProxy} from "../../../../api/common/StoreProxy";

export default {
    name: "MissingImageReport",

    data() {
        return {
            isLoading: true,
            results: {
                missingImages: []
            },
            table: {
                columns: [
                    {label: 'Part Number', field: 'partNumber', filterable: false},
                    {label: 'Category', field: 'category', filterable: false}
                ],
                pagination: {
                    enabled: true,
                    mode: 'pages',
                    perPage: 20,
                }
            }

        }

    },
    components: {
        Loading,
        VueGoodTable
    },
    created(){
        this._$imageService = new ImageService(StoreProxy.getAuth(this.$store));
    },
    mounted(){

        this._$imageService.missingImages().then(data => {

            if (data == null){
                this.results.missingImages = [];
            }
            else{
                this.results.missingImages = data;
            }

            this.isLoading = false;

        }).catch(error => {

            this.isLoading = false;
        });
    },
    computed: {},
    methods: {}
}